<template>
  <span>
    <span v-if="date">
      <span
        v-if="showTimeAgo"
        @click="handleToggleDateFormat"
        style="cursor: pointer"
    >
      <time-ago
          :refresh="1"
          :datetime=" date.toDate()"
      /> ago
    </span>
      <span
          v-else
          @click="handleToggleDateFormat"
          style="cursor: pointer"
      >
      {{ formattedDate(date) }}
    </span>
    </span>
  </span>
</template>
<script>

import TimeAgo from "vue2-timeago";
import moment from "moment";
export default {
  name: "Date_Format_Toggle",
  components: {
    TimeAgo
  },
  props: {
    date: {
      type: Object,
      required: true,
      default: () => { return {}}
    }
  },
  methods: {
    handleToggleDateFormat(){
      this.showTimeAgo = !this.showTimeAgo;
    },
    formattedDate(date) {
      //@TODo - Date format should be standardized even for apps
      return moment(new Date(date.toDate())).format("dddd, DD MMMM YYYY");
    }
  },
  data() {
    return {
      showTimeAgo: false
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
